module.exports = __webpack_public_path__ + "static/media/logo.75e694f4.png";